export const formatNumber = (n: number | null | undefined, decimals = 2): string => {
  if (n === null || n === undefined) return "—";
  return n.toLocaleString("fr-FR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatCurrency = (amount: number | null | undefined, currency: string = "XAF"): string => {
  return `${formatNumber(amount)} ${currency}`;
};
